import { render, staticRenderFns } from "./ArticleRegwall.vue?vue&type=template&id=909d86ea&scoped=true"
import script from "./ArticleRegwall.vue?vue&type=script&lang=ts"
export * from "./ArticleRegwall.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRegwall.vue?vue&type=style&index=0&id=909d86ea&prod&lang=scss"
import style1 from "./ArticleRegwall.vue?vue&type=style&index=1&id=909d86ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909d86ea",
  null
  
)

export default component.exports